import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Stack
} from '@mui/material';
import {
  Construction as ConstructionIcon,
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';

const ComingSoonPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 } }}>
      {/* Header */}
      <Paper 
        sx={{ 
          p: 3, 
          mb: 3, 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
          color: 'white' 
        }}
      >
        <Typography 
          variant="h4" 
          component="h1" 
          sx={{ fontWeight: 'bold', mb: 1 }}
        >
          <ConstructionIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
          Coming Soon
        </Typography>
        
      </Paper>

      {/* Content */}
      <Paper sx={{ p: 4 }}>
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            textAlign: 'center',
            py: 4
          }}
        >
          <ConstructionIcon 
            sx={{ 
              fontSize: 120, 
              color: 'primary.main', 
              mb: 3,
              opacity: 0.7
            }} 
          />
          
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
            Almost there!
          </Typography>
          
          <Typography 
            variant="body1" 
            color="text.secondary" 
            sx={{ mb: 4, maxWidth: 600 }}
          >
            This page and other features will be available to you as we approach the official launch date.
            We're excited to get things going!
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button
              variant="contained"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
              size="large"
            >
              Go to Dashboard
            </Button>
            
            {/* <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={handleGoBack}
              size="large"
            >
              Go Back
            </Button> */}
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

export default ComingSoonPage;
